import * as React from "react";
import {
  ArrayInput,
  Create,
  CreateProps,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";

const BenefitsCreate = (props: CreateProps) => {
  const [locale] = useLocaleState();

  return (
    <Create {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="sectionTitle" label="benefits.title" />

          <TextInput
            fullWidth
            source="sectionSubtitle"
            label="benefits.subtitle"
          />
          <TextInput
            fullWidth
            source="sectionDescription"
            label="benefits.description"
          />

          <ArrayInput source="benefits" label="benefits.benefits">
            <SimpleFormIterator fullWidth>
              <ImageCropInput
                slot="icon"
                fullWidth
                sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
                label={false}
                source="icon"
              />

              <TextInput
                fullWidth
                source="title"
                label="benefits.benefitTitle"
              />
              <TextInput
                fullWidth
                source="description"
                label="benefits.benefitDescription"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Create>
  );
};

export default BenefitsCreate;
